import React from 'react';

const index = () => {
  return (
    <div className={'loader-body container-fluid my-md-5'}>
      <div className="container">
        <div className="row justify-content-md-center align-items-center">
          <div className="lds-ring">
            <div />
            <div />
            <div />
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
